import React from 'react'
import SubTitle from '../../../ui/SubTitle'
import { Link, useParams } from 'react-router-dom'
import { Plus } from 'lucide-react'
import SpecialChangeBox from './SpecialChangeBox'
import { Instruction } from '../../../../types/modules/product.type'
import { PermissionGate } from '../../../admin/PermissionGate'
import { PermissionsKey } from '../../../../data/permissions'

type Props ={
  specialChanges:Instruction[],
  storeId?:number
}

function ProductSpecialChangesList({specialChanges,storeId}:Props) {
  const { productId } = useParams<{ productId: string }>();
  const numericProductId = productId ? parseInt(productId) : 0;
  return (
    <div className='w-[330px]'>
         <div className='flex justify-between items-center'>
            <SubTitle title='special_changes'/>
            <PermissionGate permissions={[PermissionsKey.UpdateProduct]}>
              <Link to={storeId?`/admin/stores/${storeId}/products/${numericProductId}/instructions?back=true` :`/store/products/${numericProductId}/instructions?back=true`}>
                <Plus size={18} className=' text-Black'/>
            </Link>
            </PermissionGate>
        </div>
        <div>
            {
              specialChanges.map(special=>{
                return <SpecialChangeBox key={special.id+"special_change"} specialChange={special}/>
              })
            }
        </div>
    </div>
  )
}

export default ProductSpecialChangesList